import { createContext, useContext, PropsWithChildren, useState } from 'react';
import { PreloadedData } from 'server/types';

const PreloadedDataContext = createContext<PreloadedData | undefined>(undefined);

export const PreloadedDataProvider = ({
  children,
  preloadedData: initialData,
}: PropsWithChildren<{ preloadedData?: PreloadedData }>) => {
  const [preloadedData] = useState<PreloadedData | undefined>(initialData ?? {});

  return (
    <PreloadedDataContext.Provider value={preloadedData}>{children}</PreloadedDataContext.Provider>
  );
};

export const usePreloadedData = () => {
  const context = useContext(PreloadedDataContext);
  if (!context) {
    throw new Error('usePreloadedData must be used within a PreloadedDataProvider');
  }
  return context;
};
